import styled from 'styled-components';

const darkGrey = '#333333';
const grey = '#969696';
const blue = '#3D02FF';
const purple = '#FE1251';
const labelColor = darkGrey;
const inputBottomBorderColor = grey;
const errorTextColor = purple;

const getLabelColor = ({ active, theme }) => {
    const isDarkMode = theme.mode === 'dark';
    if (isDarkMode) {
        return 'white';
    }
    return (active ? blue : labelColor);
};
export const getIframeInputColor = ({ mode }, isActive) => {
    const isDarkMode = mode === 'dark';
    // eslint-disable-next-line no-nested-ternary
    return (isDarkMode ? 'white' : isActive ? blue : darkGrey);
};

export const Container = styled.div`
    position: relative;
    display: block;
    /* a fixed-hight input and a room for an ErrorContainer */
    min-height: 85px;
    width: 100%;
    margin-bottom: 15px;
    transition: border .2s ease;
    `;

export const Label = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    height: ${({ active }) => (active ? '24px' : '60px')};
    font-size: ${({ active }) => (active ? '14px' : '16px')};
    font-family: Inter, sans-serif;
    line-height: 1;
    font-weight: 300;
    color: ${(props) => getLabelColor(props)};
    transition: all .2s cubic-bezier(0.13, 0.6, 0.43, 0.92);
    `;

export const InputWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    border-bottom: 2px solid ${(props) => (props.active ? blue : inputBottomBorderColor)};
`;

export const ErrorContainer = styled.span`
    display: block;
    /* InputWrapper & Label are positioned absolutely, so padding works as a placeholder */
    padding-top: 65px;
    font-weight: 300;
    font-size: 14px;
    line-height: 1.35;
    color: ${errorTextColor};
`;
